module.exports = __webpack_public_path__ + "static/media/dealer-logo.d70b496f.jpg";